// @flow
import React, {type Node} from 'react'
import {type RelayFragmentContainer, createFragmentContainer, graphql} from 'react-relay'

import ProposeNow from 'components/proposals/controls/ProposeNow'
import type {Proposal} from './types'

type Props = {|
  proposal: Proposal,
  toggle: any,
|}

function ProposeNowContainer({proposal, toggle}: Props): Node {
  return (
    <ProposeNow
      idPrefix="edit-proposal"
      proposal={proposal}
      onSuccess={toggle}
      buttonTag="button"
      className="btn btn-lg btn-primary"
    />
  )
}

export default (createFragmentContainer(ProposeNowContainer, {
  proposal: graphql`
   fragment ProposeNowContainer_proposal on Proposal {
     ...ProposeNow_proposal
   }
 `,
}): RelayFragmentContainer<typeof(ProposeNowContainer)>)
